/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import RolePermissionsTable from './RolePermissionsTable'
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import TeamPermissionsTable from './TeamPermissionsTable'
import ToggleConfirm from '../../../components/Projects/ToggleConfirm';





const Permissions = () => {

    const [activeTab, setActiveTab] = useState('rolePermisTab');
    const [openToggleConfirm, setOpenToggleConfirm] = useState(false);
    const tabsBtnStyle = {
        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
    }

    return (
        <>
            <Box sx={{
                overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                maxWidth: '100%',
            }}>
                {/* Tabs */}
                <Box display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}>
                    <Button onClick={() => setActiveTab('rolePermisTab')} variant="contained" sx={{
                        tabsBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'rolePermisTab' ? '#0076FE' : '#fff', color: activeTab === 'rolePermisTab' ? '#fff' : '#64748B', border: activeTab === 'rolePermisTab' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Role permissions</Button>
                    <Button onClick={() => setActiveTab('teamPermisTab')} variant="contained" sx={{
                        tabsBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'teamPermisTab' ? '#0076FE' : '#fff',
                        color: activeTab === 'teamPermisTab' ? '#fff' : '#64748B', border: activeTab === 'teamPermisTab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Team permissions
                    </Button>
                </Box>
                {/* Tab Panel Content */}
            </Box>
            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                {/* start Role permissions */}
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="rolePermisTab">
                    <Box sx={{ m: '16px auto 0' }}>
                        <RolePermissionsTable /></Box>
                </CustomTabPanel>
                {/* End Role permissions */}
                {/* Start Team permissions */}
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="teamPermisTab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Team permission structure
                            <Tooltip title="Control Team lead permissions, when added to projects through their teams" arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>
                            Allow team leaders to gain a complete overview of every project participant, showcasing their names, activity records, screenshots, and timesheet entries, even for individuals outside their immediate team.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '16px', lg: '15px', md: '14px', sm: '14px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Allow Team leads to manage projects
                        </Typography>
                        <Box onClick={() => setOpenToggleConfirm(true)}>
                            <ToggleSwitch />
                        </Box>
                        <ToggleConfirm open={openToggleConfirm} onClose={() => setOpenToggleConfirm(false)} />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ m: '16px auto 24px', p: '14px', border: 'none', borderRadius: '8px', backgroundColor: '#FFF3DE' }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '10px', fontSize: '15px', fontWeight: '500', color: '#E69805', fontFamily: 'Manrope' }}>
                            <img class="img-fluid" alt="accordance icon" src="./assets/images/app-activity/icon2.png" />
                            The settings for the Team Lead do not align with the organization's default configurations. To adjust the settings for each Team Lead, simply modify the Project role within the respective Teams.</Typography>
                    </Box>

                    <Box sx={{ marginBottom: '20px' }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>

                            General settings</Typography>
                        <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Update the permissions for all team leaders according to the settings outlined below.</Typography>
                    </Box>
                    <TeamPermissionsTable />
                </CustomTabPanel>
                {/* End Team permissions */}


            </Box>


        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box p={2}>{children}</Box>;
};


export default Permissions
